import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import { TextInput } from '@dbk/ui-forms';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H3 } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import { List, ListItem } from '@dbk/ui-list';
import Modal from '@dbk/ui-modal';
import { LoadingCircle } from '../../../../components/common/loading';
import paymentData from '../../../../data/paymenttypes.json';
import { PaymentIcon, InternalTransferIcon, ErrorIcon } from '../../../../components/common/icons';
import styles from './pymtselection.styles';
import { ROUTES } from '../../../../constants';
import { PAYMENT_TYPE} from '../../constant';
import { EBANKINGWEBLUX, EBANKINGWEBUK, KEY_CODE } from '../../../../constants';
import envConfig from '../../../../../db-env-build';
import { RM_REGION, RM_REGION_UK } from '../../../../../@extension/CH/src/constants';

const { DEBIT_ACCOUNT_LIST, LOADING ,DESTINATION, TEMPLATE} = ROUTES.PAYMENT ;

class PaymentSelection extends PureComponent {
  state = {
    showFailModal: false,
    failMsg: ''
  }

  createNewPayment =(psPosId, e)=> {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      this.props.payments.refreshPayments();
      // console.log(document.getElementById("paymentTypeListNew"), "XYZ");
      this.props.payments.setPosId(psPosId);
      this.props.payments.setCreateNewModal(true);
    }
  }
  
  cashNewPayment=async (e,psPosId)=> {
    e.stopPropagation();
    await this.props.payments.setIsCashPaymentFlow(true);
    this.createNewPayment(psPosId)
  }

  toggleCreateModal = state => this.props.payments.setCreateNewModal(state)
  
  handlePress = async (payment, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      const psPosId = this.props.payments.psPosId;
      // display a loading circle
      if(payment === "payment-templates"){
        this.props.changePage(TEMPLATE);
        this.props.payments.setDisableTabs(true);
        return;
      }
      this.props.payments.resetTemplateVariables();
      await this.props.payments.initializeTx(payment);
      if (payment.includes(PAYMENT_TYPE.internal)) this.props.payments.setSelectCreditAccFlag(true)
      setTimeout(() => {
        this.props.payments.getCountryList({ country: "all-country", isAllCountry: true });
        const { initializeTxFails } = this.props.payments
        if (initializeTxFails) {
          let failMsg = this.props.i18n.messages['app.payments.failToConnect']
          const showFailModal = true
          if (initializeTxFails==='payments.error.active.webtxn') {
            failMsg = this.props.i18n.messages['app.payment.error.active.webtxn']
          } else if (initializeTxFails==='acp.down') {
            failMsg = this.props.i18n.messages['app.payment.error.acp.down']
          }
          this.setState({ showFailModal, failMsg })
          //enable tabs when intitiate payment fails
          this.props.payments.setDisableTabs(false);
        } else if (psPosId) {
          this.props.changePage(LOADING);
          this.props.payments.setDisableTabs(true);
        } else {
          if(payment.includes(PAYMENT_TYPE.internal))
            this.props.changePage(DEBIT_ACCOUNT_LIST);
          else
            this.props.changePage(DESTINATION); 
          this.props.payments.setDisableTabs(true);
        }
      }, 100);
    }
  }

  componentDidUpdate() {
    if(document.querySelector('div.forHeighLight')){
      document.querySelector('div.forHeighLight').focus()
    }
  }

  componentWillUnmount() {
    this.toggleCreateModal(false)
  }
  render() {
    const {
      i18n: { messages },
      payments,
      pageName,
      psPosId,
      auth: { isPaymentCheck, vascoActivated, entitlement },
      alerts: { isAvaloqDown }
    } = this.props;
    let paymentTypeList = " ";
    if(envConfig.envConfig === EBANKINGWEBLUX || envConfig.rmRegion === RM_REGION){
      paymentTypeList =  paymentData.optionsForLux;
    }else if(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK){
      paymentTypeList = paymentData.optionsForUK;
    }else{
      paymentTypeList = paymentData.options.filter((payment)=>payment.active);
    }
    const isModalVisible = payments.createNewModal;
    const paymentEnabled = entitlement.payment && isPaymentCheck && vascoActivated;

    return (
      <div> 
        <div style={StyleSheet.flatten(styles.mainWrapper)}>
          {/* {pageName !== "position-page" &&
          <Button testID="btn_payments_createNew_index_test"
            size="medium"
            onPress={() => this.createNewPayment()}>
            {messages['app.payments.createNewButton']}
          </Button>
          } */}
        </div>
        <div>
          {pageName === "position-page" && paymentEnabled &&
          <Button 
            tabIndex={0}
            testID="btn_positionsAssets_newPayment_index_test"
            tertiary  
            onKeyDown={(e) => this.createNewPayment(psPosId, e)}
            onPress={() => this.createNewPayment(psPosId)}
            disabled={isAvaloqDown}>
            {messages['app.payments.newPayment']}
          </Button>}

          {(pageName !== "position-page" && paymentEnabled && pageName === "cashposition-page")&&
          <Button 
            testID="btn_positionsCash_newPayment_index_test"
             size="medium"
             onPress={(e) => { 
             this.cashNewPayment(e,psPosId)}}>
             {messages['app.payments.newPayment']}
           </Button>}

        </div>
        <View>
          <Modal
            disableOutsideClick
            testID="modal_paymentModal_index_test"
            isActive={isModalVisible}
            className={"payment-list-modal"}
            style={styles.modalstyle}
            onClose={() => {this.toggleCreateModal(false) ; this.props.payments.setIsCashPaymentFlow(false)} }
            header={messages['app.payments.createNewButton']}
            content={
              payments.isInitializingTx ?
              <LoadingCircle /> : 
              <List 
                size="large"
                testID="paymentTypeList"
                className="payment-type-list"
                style={{ maxWidth: 'none' }} 
                role="listbox"
                aria-label={messages['app.payment.filter.selectPaymentType']} >
                {paymentTypeList.map((option) =>
                <ListItem testID={"list_payment_modal_test_"+ option.key}
                  tabIndex="0"
                  key={option.key} 
                  aria-label={messages[option.title]}
                  className="payment-type-list-item forHeighLight" 
                  onKeyDown={(e) => this.handlePress(option.key, e)}
                  onClick={() => this.handlePress(option.key)}>
                  <div style={StyleSheet.flatten(styles.cursorPointer)}>
                  <div className="row-fluid">
                    {option.key === 'internal-payments' ?
                      <InternalTransferIcon
                        width={24}
                        height={24} /> :
                      <PaymentIcon
                        width={24}
                        height={24} />}
                    <span className='payment-type-list__text' style={StyleSheet.flatten(styles.textColor)}>
                      {messages[option.title]}
                    </span>
                  </div>
                  </div>
                </ListItem>
                )}
              </List>
              
            } />
        </View>
        <Modal 
          isActive={this.state.showFailModal}
          onClose={() => this.setState({ showFailModal: false })}
          content={
            <div className="small-12 row margin20">
              <div className="column small-2">
                <ErrorIcon width={30} height={30} />
              </div>
              <div className="column small-10" role="alert" tabIndex={0}>
                <Text>
                  {this.state.failMsg}
                </Text>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    payments: {
      createNewModal: true,
      setCreateNewModal: { $set: 'createNewModal' },
      initializeTx: { $call: 'initializeTx' },
      psPosId: true,
      isCashPaymentFlow: true,
      setSelectedBeneficiaryDetail: { $set: 'selectedBeneficiaryDetail' },
      setPosId: { $set: 'psPosId' },
      setIsCashPaymentFlow: { $set: 'isCashPaymentFlow' },
      resetForm: { $call: 'resetForm' },
      refreshPayments: { $call: 'refreshPayments' },
      initializeTxFails: true,
      isInitializingTx: true,
      disableTabs:true,
      setDisableTabs: { $set: 'disableTabs'},
      selectCreditAccFlag: true,
      setSelectCreditAccFlag: { $set: 'selectCreditAccFlag' },
      resetTemplateVariables: { $call : 'resetTemplateVariables'},
      getCountryList: { $call: 'searchCountry' }
    },
    changePage: { $call: 'ui.history.push' },
    auth: {
      entitlement: true,
      isPaymentCheck: true,
      vascoActivated: true,
    },
    alerts: {
      isAvaloqDown: true,
    }
  },
})(PaymentSelection);